import { Array as A, Equivalence } from 'effect';

export type SearchParamPair = [key: string, value: string];

const samePair = A.getEquivalence(Equivalence.string);

// Merge extra key/value pairs into a query string, dropping any pair that repeats one already
// there. Distinct values under one key survive: `text[]` carrying two tags is two entries, and that
// is a narrower query, not a repeat. Returns the search WITHOUT a leading `?`, empty when nothing
// is left, so a caller can tell "no query" from "a query" without parsing it again.
export const mergeSearchParams = (search: string, extraPairs: SearchParamPair[] = []): string =>
  new URLSearchParams(A.dedupeWith([...new URLSearchParams(search), ...extraPairs], samePair)).toString();
